import React, { type FunctionComponent } from 'react'
import {
  MetricCard,
  MetricCardsContainer,
  type MetricCardProps,
} from '@retailer-platform/shared-components'
import { InsightsPortalWidgetContainer } from 'domains/insights-portal/utils/insights-portal.styles'
import { InsightsStretchedMetricCard } from './InsightsStretchedMetricCard'

interface InsightsPortalMetricsProps {
  isLoading: boolean
  onClick: (metric: string) => void
  selectedMetric: string
  layoutVariant?: 'column' | 'row'
  height?: number
  metricInfoWithData: {
    apiMetric: string
    metricName: string
    value: number
    comparisonValue: number
    formatter?: (value: number) => string
    tooltip?: string
    desiredDirection?: MetricCardProps['desiredDirection']
    active?: boolean
  }[]
}

export const InsightsPortalMetrics: FunctionComponent<InsightsPortalMetricsProps> = ({
  metricInfoWithData,
  onClick,
  isLoading,
  selectedMetric,
  layoutVariant = 'row',
  height,
}) => (
  <InsightsPortalWidgetContainer
    style={layoutVariant === 'row' ? { paddingTop: '15px' } : { padding: 0 }}
  >
    <MetricCardsContainer css={{ flexDirection: layoutVariant, height }}>
      {metricInfoWithData.map(
        (
          {
            metricName,
            formatter,
            comparisonValue,
            value,
            desiredDirection,
            tooltip,
            apiMetric,
            active,
          },
          index
        ) => {
          const metricCardProps = {
            title: metricName,
            key: `metric-card-${metricName}`,
            valueFormatFn: formatter || (() => value.toString()),
            comparisonValue,
            value,
            desiredDirection,
            isLoading,
            'data-testid': `overview-widget-${apiMetric}-metric-card`,
            onClick: () => onClick(apiMetric),
            active: selectedMetric === apiMetric || active,
          }

          const rowProps = {
            ...metricCardProps,
            withWhiteBackground: true,
            tooltip,
          }
          return (
            <div key={`apiMetric-${index}`}>
              {layoutVariant === 'row' ? (
                <MetricCard {...rowProps} />
              ) : (
                <InsightsStretchedMetricCard {...metricCardProps} />
              )}
            </div>
          )
        }
      )}
    </MetricCardsContainer>
  </InsightsPortalWidgetContainer>
)
